module.exports = __webpack_public_path__ + "static/fonts/rajdhani-bold-webfont.4dd0db2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-bold-webfont.woff2
// module id = 96
// module chunks = 0